import {
  CRUD_ACCOUNT_ACTIVITY,
  CRUD_CAMPAIGN_ACTIVITY,
  CRUD_CONTACT_ACTIVITY,
  CRUD_CONTRACT_ACTIVITY,
  CRUD_CUSTOMER_ACTIVITY,
  CRUD_INQUIRY_ACTIVITY,
  CRUD_LEAD_ACTIVITY,
  CRUD_OPPORTUNITY_ACTIVITY,
  CRUD_ORDER_ACTIVITY,
  CRUD_PROSPECT_ACTIVITY,
  GET_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID,
  GET_CAMPAIGN_ACTIVITY_BY_CAMPAIGN_ID,
  GET_CONTACT_ACTIVITY_BY_CONTACT_ID,
  GET_CONTRACT_ACTIVITY_BY_CONTRACT_ID,
  GET_CUSTOMER_ACTIVITY_BY_CUSTOMER_ID,
  GET_INQUIRY_ACTIVITY_BY_INQUIRY_ID,
  GET_LEAD_ACTIVITY_BY_LEAD_ID,
  GET_OPPORTUNITY_ACTIVITY_BY_OPPORTUNITY_ID,
  GET_ORDER_ACTIVITY_BY_ORDER_ID,
  GET_PROSPECT_ACTIVITY_BY_PROSPECT_ID,
} from "@routes";
import {
  // Account
  addAccountActivity,
  // Campaign
  addCampaignActivity,
  // Contact
  addContactActivity,
  // Contract
  addContractActivity,
  // Customer
  addCustomerActivity,
  // Inquiry
  addInquiryActivity,
  // Lead
  addLeadActivity,
  // Opportunity
  addOpportunityActivity,
  // Order
  addOrderActivity,
  // Prospect
  addProspectActivity,
  deleteAccountActivity,
  deleteCampaignActivity,
  deleteContactActivity,
  deleteContractActivity,
  deleteCustomerActivity,
  deleteInquiryActivity,
  deleteLeadActivity,
  deleteOpportunityActivity,
  deleteOrderActivity,
  deleteProspectActivity,
  getAccountActivity,
  getCampaignActivity,
  getContactActivity,
  getContractActivity,
  getCustomerActivity,
  getInquiryActivity,
  getLeadActivity,
  getOpportunityActivity,
  getOrderActivity,
  getProspectActivity,
  updateAccountActivity,
  updateCampaignActivity,
  updateContactActivity,
  updateContractActivity,
  updateCustomerActivity,
  updateInquiryActivity,
  updateLeadActivity,
  updateOpportunityActivity,
  updateOrderActivity,
  updateProspectActivity,
} from "./activitySlice";

// Lazy getter function for Activity API map
export const getActivityApiMap = () => ({
  contract: {
    entityType: "contract",
    idKey: "contractId",
    get: getContractActivity,
    add: addContractActivity,
    update: updateContractActivity,
    delete: deleteContractActivity,
    endpoints: {
      get: GET_CONTRACT_ACTIVITY_BY_CONTRACT_ID,
      add: CRUD_CONTRACT_ACTIVITY,
      update: CRUD_CONTRACT_ACTIVITY,
      delete: CRUD_CONTRACT_ACTIVITY,
    },
  },
  "customer-account": {
    entityType: "customer-account",
    idKey: "customerAccountId",
    get: getAccountActivity,
    add: addAccountActivity,
    update: updateAccountActivity,
    delete: deleteAccountActivity,
    endpoints: {
      get: GET_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID,
      add: CRUD_ACCOUNT_ACTIVITY,
      update: CRUD_ACCOUNT_ACTIVITY,
      delete: CRUD_ACCOUNT_ACTIVITY,
    },
  },
  account: {
    entityType: "customer-account",
    idKey: "customerAccountId",
    get: getAccountActivity,
    add: addAccountActivity,
    update: updateAccountActivity,
    delete: deleteAccountActivity,
    endpoints: {
      get: GET_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID,
      add: CRUD_ACCOUNT_ACTIVITY,
      update: CRUD_ACCOUNT_ACTIVITY,
      delete: CRUD_ACCOUNT_ACTIVITY,
    },
  },
  opportunity: {
    entityType: "opportunity",
    idKey: "opportunityId",
    get: getOpportunityActivity,
    add: addOpportunityActivity,
    update: updateOpportunityActivity,
    delete: deleteOpportunityActivity,
    endpoints: {
      get: GET_OPPORTUNITY_ACTIVITY_BY_OPPORTUNITY_ID,
      add: CRUD_OPPORTUNITY_ACTIVITY,
      update: CRUD_OPPORTUNITY_ACTIVITY,
      delete: CRUD_OPPORTUNITY_ACTIVITY,
    },
  },
  contact: {
    entityType: "contact",
    idKey: "contactId",
    get: getContactActivity,
    add: addContactActivity,
    update: updateContactActivity,
    delete: deleteContactActivity,
    endpoints: {
      get: GET_CONTACT_ACTIVITY_BY_CONTACT_ID,
      add: CRUD_CONTACT_ACTIVITY,
      update: CRUD_CONTACT_ACTIVITY,
      delete: CRUD_CONTACT_ACTIVITY,
    },
  },
  lead: {
    entityType: "lead",
    idKey: "leadId",
    get: getLeadActivity,
    add: addLeadActivity,
    update: updateLeadActivity,
    delete: deleteLeadActivity,
    endpoints: {
      get: GET_LEAD_ACTIVITY_BY_LEAD_ID,
      add: CRUD_LEAD_ACTIVITY,
      update: CRUD_LEAD_ACTIVITY,
      delete: CRUD_LEAD_ACTIVITY,
    },
  },
  campaign: {
    entityType: "campaign",
    idKey: "campaignId",
    get: getCampaignActivity,
    add: addCampaignActivity,
    update: updateCampaignActivity,
    delete: deleteCampaignActivity,
    endpoints: {
      get: GET_CAMPAIGN_ACTIVITY_BY_CAMPAIGN_ID,
      add: CRUD_CAMPAIGN_ACTIVITY,
      update: CRUD_CAMPAIGN_ACTIVITY,
      delete: CRUD_CAMPAIGN_ACTIVITY,
    },
  },
  inquiry: {
    entityType: "inquiry",
    idKey: "inquiryId",
    get: getInquiryActivity,
    add: addInquiryActivity,
    update: updateInquiryActivity,
    delete: deleteInquiryActivity,
    endpoints: {
      get: GET_INQUIRY_ACTIVITY_BY_INQUIRY_ID,
      add: CRUD_INQUIRY_ACTIVITY,
      update: CRUD_INQUIRY_ACTIVITY,
      delete: CRUD_INQUIRY_ACTIVITY,
    },
  },
  prospect: {
    entityType: "prospect",
    idKey: "prospectId",
    get: getProspectActivity,
    add: addProspectActivity,
    update: updateProspectActivity,
    delete: deleteProspectActivity,
    endpoints: {
      get: GET_PROSPECT_ACTIVITY_BY_PROSPECT_ID,
      add: CRUD_PROSPECT_ACTIVITY,
      update: CRUD_PROSPECT_ACTIVITY,
      delete: CRUD_PROSPECT_ACTIVITY,
    },
  },
  customer: {
    entityType: "customer",
    idKey: "customerId",
    get: getCustomerActivity,
    add: addCustomerActivity,
    update: updateCustomerActivity,
    delete: deleteCustomerActivity,
    endpoints: {
      get: GET_CUSTOMER_ACTIVITY_BY_CUSTOMER_ID,
      add: CRUD_CUSTOMER_ACTIVITY,
      update: CRUD_CUSTOMER_ACTIVITY,
      delete: CRUD_CUSTOMER_ACTIVITY,
    },
  },
  order: {
    entityType: "order",
    idKey: "orderId",
    get: getOrderActivity,
    add: addOrderActivity,
    update: updateOrderActivity,
    delete: deleteOrderActivity,
    endpoints: {
      get: GET_ORDER_ACTIVITY_BY_ORDER_ID,
      add: CRUD_ORDER_ACTIVITY,
      update: CRUD_ORDER_ACTIVITY,
      delete: CRUD_ORDER_ACTIVITY,
    },
  },
});

// Proxy to allow property access while resolving lazily
export const ACTIVITY_API_MAP = new Proxy(
  {},
  {
    get: (_target, prop) => getActivityApiMap()[prop],
  }
);

const ENTITY_FLAG_LIST = [
  { flag: "forOrder", type: "order" },
  { flag: "forContract", type: "contract" },
  { flag: "forAccount", type: "customer-account" },
  { flag: "forContact", type: "contact" },
  { flag: "forOpportunity", type: "opportunity" },
  { flag: "forLead", type: "lead" },
  { flag: "forCampaign", type: "campaign" },
  { flag: "forInquiry", type: "inquiry" },
  { flag: "forProspect", type: "prospect" },
  { flag: "forCustomer", type: "customer" },
];

const ENTITY_ID_KEY_LIST = [
  { key: "orderId", type: "order" },
  { key: "contractId", type: "contract" },
  { key: "customerAccountId", type: "customer-account" },
  { key: "accountId", type: "customer-account" },
  { key: "contactId", type: "contact" },
  { key: "opportunityId", type: "opportunity" },
  { key: "leadId", type: "lead" },
  { key: "campaignId", type: "campaign" },
  { key: "inquiryId", type: "inquiry" },
  { key: "prospectId", type: "prospect" },
  { key: "customerId", type: "customer" },
];

const ENTITY_NAME_ALIASES = {
  account: "customer-account",
  customeraccount: "customer-account",
};

const normalizeEntityString = (str) => {
  const normalized = str.toLowerCase().trim();
  return ENTITY_NAME_ALIASES[normalized] || normalized;
};

const isValidEntityId = (value) =>
  Boolean(value && value !== true && value !== "true");

const resolveFromPropsObject = (props) => {
  if (props?.entityType) {
    return resolveActivityEntityType(props.entityType);
  }

  const matchedFlag = ENTITY_FLAG_LIST.find(({ flag }) => Boolean(props[flag]));
  if (matchedFlag) {
    return matchedFlag.type;
  }

  const matchedId = ENTITY_ID_KEY_LIST.find(({ key }) => isValidEntityId(props[key]));
  return matchedId ? matchedId.type : null;
};

/**
 * Resolves the entity name ('contract', 'customer-account', etc.)
 * from props or an entity string.
 */
export const resolveActivityEntityType = (propsOrType) => {
  if (!propsOrType) return null;
  if (typeof propsOrType === "string") return normalizeEntityString(propsOrType);
  if (typeof propsOrType === "object") return resolveFromPropsObject(propsOrType);
  return null;
};

/**
 * Returns the exact Activity API functions and endpoints for an entity.
 * Prints clear logs indicating exactly what API endpoints are being hit.
 */
export const getActivityApi = (propsOrType) => {
  const map = getActivityApiMap();
  const entityType = resolveActivityEntityType(propsOrType) || "contract";
  const apiConfig = map[entityType] || map.contract;

  // Log which API is being targeted to ensure full developer visibility
  console.log(
    `[Activity Service] Target Entity: "${apiConfig.entityType.toUpperCase()}" | ` +
    `GET: ${apiConfig.endpoints.get} | ` +
    `ADD: ${apiConfig.endpoints.add} | ` +
    `UPDATE: ${apiConfig.endpoints.update} | ` +
    `DELETE: ${apiConfig.endpoints.delete}`
  );

  return apiConfig;
};
